run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','adminPanel'];

//funcion donde se definen la run

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,adminPanel) {
                MenuConstant[0]['menu'].push(adminPanel);
}


// WEBPACK FOOTER //
// ./src/app/admin-panel/adminPanel.run.js